import { ClassNames } from '@emotion/react';
import { ProfessionalTypeEnum } from '@gql/graphql';
import {
  Button,
  HeaderSearch as HeaderSearchComponent,
  HeaderSearchInputWrapper,
  InputSelect,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Form } from 'formik';
import type { FC } from 'react';
import { useMemo } from 'react';
import { FaSearch } from 'react-icons/fa';
import * as Styled from './styled';
import type { HeaderSearchProps } from './types';

export const HeaderSearch: FC<HeaderSearchProps> = (props) => {
  const { proSearch, title, hasMap } = props;

  const { translate } = useTranslation();

  const placeholderSearch = useMemo(() => {
    if (proSearch.values.proType === ProfessionalTypeEnum.VET) {
      return translate('common.inputs.searchNameService.placeholder');
    }

    return translate('common.inputs.searchKeyName.placeholder');
  }, [proSearch.values.proType, translate]);

  return (
    <Form>
      <ClassNames>
        {({ css: classNameCss }) => {
          const wrapperClassname = classNameCss(Styled.HeaderChildrenWrapperStyled({ hasMap }));
          return (
            <HeaderSearchComponent
              title={title}
              childrenWrapperContainerProps={{ className: wrapperClassname }}
              hasMobileWrap
            >
              <>
                <HeaderSearchInputWrapper hasMobileWrap>
                  <InputSelect<number>
                    loading={proSearch.loading}
                    placeholder={placeholderSearch}
                    value={proSearch.tempValues.search ?? proSearch.values.search}
                    search={proSearch.inputValues.search}
                    selectOptions={proSearch.options.search}
                    onSearchChange={(search) => {
                      proSearch.fieldChangeHandler({ type: 'search', value: search });
                    }}
                    onSelect={(selected) => {
                      proSearch.fieldSelectHandler({ type: 'search', value: selected });
                    }}
                  />
                </HeaderSearchInputWrapper>
                <HeaderSearchInputWrapper hasMobileWrap>
                  <InputSelect<string>
                    placeholder={translate('common.inputs.where.placeholder')}
                    value={proSearch.tempValues.location ?? proSearch.values.location}
                    search={proSearch.inputValues.location}
                    selectOptions={proSearch.options.location}
                    onSearchChange={(search) => {
                      proSearch.fieldChangeHandler({ type: 'location', value: search });
                    }}
                    onSelect={(selected) => {
                      proSearch.fieldSelectHandler({ type: 'location', value: selected });
                    }}
                    loading={proSearch.suggestionsLoading}
                  />
                </HeaderSearchInputWrapper>
                <HeaderSearchInputWrapper width="150px" hasMobileWrap fullWidthBreakpoint="tablet">
                  <Button
                    color="blue"
                    onClick={() => {
                      proSearch.submit();
                    }}
                  >
                    <FaSearch />
                  </Button>
                </HeaderSearchInputWrapper>
              </>
            </HeaderSearchComponent>
          );
        }}
      </ClassNames>
    </Form>
  );
};
